import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
export const TipText = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ _jsx("p", {
        className: classNames("text-sm text-neutral-800 !leading-[22px] inline", className),
        children: children
    });
};
